import React, { useState } from 'react';
import './header.sass';
import Logo from '../../assets/Logo.png';
import { Button, ButtonSize, ButtonType } from '../../../../../components/interface/button/button';
import { Modal } from '../../../../../components/modal/modal';
import { Login } from '../../../../login/component/login.component';
import { useScrollElement } from '../../../../../components/hooks/use-scroll-element';

export const Header = ({scrollRef}) => {
    const [isVisible, setIsVisible] = useState(false);
    const {onScroll} = useScrollElement(scrollRef);

    const scrollFromModal = () => {
      setIsVisible(false);
      onScroll();
    };

    return (
        <div className='vv-landing-page-vendor-header-container'>
            <div className='vv-landing-page-vendor-header'>
                <div className='vv-landing-page-vendor-header__left'>
                    <img className='vv-landing-page-vendor-header__logo' src={Logo}/>
                    <p>Dla partnerów</p>
                </div>
                <div className='vv-landing-page-vendor-header__right'>
                    <Modal isOpen={isVisible} title='Zaloguj się' setVisible={setIsVisible} width={635} height={525}>
                        <div>
                            <Login/>
                            <div className='vv-login-modal-paragraph-container'>
                                <p>Nie masz jeszcze konta?</p>
                                <div className='join-button'>
                                    <span onClick={() => scrollFromModal()}>Dołącz</span>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Button onClick={() => setIsVisible(!isVisible)} size={ButtonSize.VENDOR} buttonType={ButtonType.TRANSPARENT} text='ZALOGUJ SIĘ'/>
                    <Button size={ButtonSize.VENDOR} buttonType={ButtonType.BLACK} text='DOŁĄCZ' onClick={() => onScroll()}/>
                </div>
            </div>
        </div>
    );
};